import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const LgrLink = (props) => {
  const { selectedGene } = props;

  if (
    selectedGene.identifiers &&
    Array.isArray(selectedGene.identifiers.lrg_id) &&
    selectedGene.identifiers.lrg_id.length > 0
  ) {
    return (
      <a
        href={getVarsoUrl(
          `http://www.lrg-sequence.org/search/?query=${selectedGene.identifiers.lrg_id[0]}`
        )}
        target="_blank"
        className="varsome-gene-link"
      >
        LRG
      </a>
    );
  }

  return null;
};

LgrLink.propTypes = {
  selectedGene: PropTypes.shape({
    identifiers: PropTypes.shape({
      lrg_id: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};

LgrLink.defaultProps = {
  selectedGene: null,
};

export default LgrLink;
